import { rawColors } from "./colors";

/**
 * Homepage-only visual tokens from Figma node 5636:208253.
 *
 * These values are intentionally kept out of the global colour and elevation
 * scales: they describe composed surfaces unique to the Home V2 experience,
 * rather than reusable brand primitives.
 */
/**
 * Home colours with no rawColors leaf, as [light, dark]. installColorVars emits them as
 * `--mb-home-*` so the page follows the light/dark mode like every rawColors token.
 */
export const homeColorVars = {
  "--mb-home-shell": [
    `linear-gradient(118.683deg, #FFFAFD 8.4178%, #F6F2FF 96.346%), ${rawColors.structural.white}`,
    "linear-gradient(118.683deg, #1A1428 8.4178%, #171126 96.346%), #171126",
  ],
  "--mb-home-hero": [
    "linear-gradient(175.146deg, #EFF6FF 16.86%, #FFFAF5 28.459%, #FFF0FD 51.657%, #EBF3FF 75.684%)",
    "linear-gradient(175.146deg, #1F2440 16.86%, #2A1F2E 28.459%, #2E1F36 51.657%, #1F2440 75.684%)",
  ],
  "--mb-home-chart": ["#F0FAF4", "rgba(34, 197, 94, 0.12)"],
  "--mb-home-negative-trend": ["#FEE2E2", "rgba(239, 68, 68, 0.16)"],
  "--mb-home-positive-trend": ["#DCFCE7", "rgba(34, 197, 94, 0.16)"],
  "--mb-home-suggestion-border": ["#A92EA0", "#D06BC7"],
  "--mb-home-briefing-summary-border": ["#E2D9F3", "#3A3152"],
} as const;

const homeVar = (name: keyof typeof homeColorVars) =>
  `var(${name}, ${homeColorVars[name][0]})`;

export const homePageTokens = {
  layout: {
    briefingDetailHeight: "24.9375rem",
  },
  background: {
    shell: homeVar("--mb-home-shell"),
    hero: homeVar("--mb-home-hero"),
    chart: homeVar("--mb-home-chart"),
    negativeTrend: homeVar("--mb-home-negative-trend"),
    positiveTrend: homeVar("--mb-home-positive-trend"),
    neutralTrend: rawColors.structural[100],
  },
  borderColor: {
    suggestion: homeVar("--mb-home-suggestion-border"),
    briefingSummary: homeVar("--mb-home-briefing-summary-border"),
  },
  borderRadius: {
    briefingCard: "0.875rem",
  },
  shadow: {
    modeSelector: "0.0625rem 0.0625rem 0.25rem rgba(89, 98, 112, 0.15)",
    selectedBriefingItem:
      "0 0.0625rem 0.125rem rgba(100, 66, 179, 0.12)",
  },
} as const;

export type HomePageTokens = typeof homePageTokens;
